webpackJsonp([1],{

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fieldQuery_FieldQuery_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fieldQuery_FieldQuery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fieldQuery_FieldQuery_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('operator-builder', {
  components: {
    FieldQuery: __WEBPACK_IMPORTED_MODULE_1__fieldQuery_FieldQuery_vue___default.a
  },
  template: '\n    <div class="operator">\n      <div class="operatorScope" v-bind:class="{ \'has-sub-query\': hasSubQuery}">\n        <el-radio-group v-model="jsonData.operator" v-on:change="onChange" v-if="hasSubQuery">\n          <el-radio-button label="OR" key="OR"></el-radio-button>\n          <el-radio-button label="AND" key="AND"></el-radio-button>\n        </el-radio-group>\n        <el-checkbox-button v-model="jsonData.operator" v-on:change="onChange" v-else label="NOT" key="not" value="-"></el-checkbox-button>\n      </div>\n      <ul class="subQueries" v-if="hasSubQuery">\n        <li v-for="q in jsonData.subQueries">\n          <sub-operator-builder v-on:removeMe="removeSubquery" v-on:operatorChange="onChange" :json-data="q"></sub-operator-builder>\n        </li>\n        <li class="newItem">\n          <div class="operatorScope"></div>\n          <el-button v-on:click="addSubquery" type="text" class="addSubqueryButton" icon="plus"></el-button>\n        </li>\n      </ul>\n      <div class="aQuery" v-else>\n        <field-query v-on:change="onChange" :query="jsonData.query"></field-query>\n      </div>\n      <div class="addRemoveQuery" v-if="!hasSubQuery">\n        <el-button v-on:click="addSubquery" v-bind:disabled="!jsonData.query.operator" type="text" class="addButton" icon="share"></el-button>\n        <el-button v-on:click="removeMe" v-if="!jsonData.root" type="text" class="closeButton" icon="delete"></el-button>      \n      </div>\n    </div>\n  ',
  computed: {
    hasSubQuery: function hasSubQuery() {
      return this.jsonData.subQueries && this.jsonData.subQueries.length;
    }
  },
  name: 'sub-operator-builder',
  props: {
    jsonData: Object
  },
  data: function data() {
    return {};
  },

  methods: {
    onChange: function onChange() {
      this.$emit('operatorChange');
    },
    getQuery: function getQuery() {
      if (this.hasSubQuery) {
        var res = [];
        for (var i in this.$children) {
          res.push(this.$children[i].getQuery());
        }
        res.join(this.jsonData.operator);
        return res;
      } else {
        return this.jsonData.operator + this.jsonData.query.q;
      }
    },
    addSubquery: function addSubquery() {
      if (!this.hasSubQuery) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.jsonData, 'subQueries', [{ operator: this.jsonData.operator, query: this.jsonData.query }]);
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.jsonData, 'operator', 'AND');
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.jsonData, 'query', '');
      }
      this.jsonData.subQueries.push({ operator: '', query: { field: '', operator: '', input: '' } });
    },
    removeMe: function removeMe() {
      if (!this.hasSubQuery) {
        this.$emit('removeMe', this.jsonData);
      }
    },
    removeSubquery: function removeSubquery(e) {
      var index = this.jsonData.subQueries.indexOf(e);
      if (this.jsonData.subQueries.length === 2) {
        var child = this.jsonData.subQueries[1 - index];
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.jsonData, 'subQueries', child.subQueries);
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.jsonData, 'operator', child.operator);
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.jsonData, 'query', child.query);
      } else {
        this.jsonData.subQueries.splice(index, 1);
      }
    }
  }
}));

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {},
  name: 'headMenu',
  methods: {},
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */].getQueries().then(function (reports) {
      this.reports = reports;
    }.bind(this));
  },
  data: function data() {
    return {
      reports: []
    };
  }
});

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__queryBuilder_queryBuilder_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__queryBuilder_queryBuilder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__queryBuilder_queryBuilder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeadMenu_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeadMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HeadMenu_vue__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    QueryBuilder: __WEBPACK_IMPORTED_MODULE_0__queryBuilder_queryBuilder_vue___default.a, headMenu: __WEBPACK_IMPORTED_MODULE_2__HeadMenu_vue___default.a
  },
  name: 'queryEditor',
  data: function data() {
    return {};
  },
  created: function created() {
    if (this.$route.params.id) {
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getAQuery(this.$route.params.id).then(function () {});
    }
  }
});

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queryBuilder_queryBuilder_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queryBuilder_queryBuilder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__queryBuilder_queryBuilder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeadMenu_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeadMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HeadMenu_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    QueryBuilder: __WEBPACK_IMPORTED_MODULE_1__queryBuilder_queryBuilder_vue___default.a, headMenu: __WEBPACK_IMPORTED_MODULE_3__HeadMenu_vue___default.a
  },
  name: 'queryEditor',
  methods: {
    editQuery: function editQuery() {
      this.$router.push({ name: 'edit', params: { id: this.$route.params.id } });
    },
    changePage: function changePage(pageNumber) {
      this.$router.push({ name: 'QueryResultPagination', params: { id: this.$route.params.id, page: pageNumber } });
    },
    mouseLeave: function mouseLeave(e) {
      this.moreDetailHeader = this.clikedMoreDetailHeader;
      this.moreDetailBody = this.clickedMoreDetailBody;
    },
    cellMouseClick: function cellMouseClick(row, column, cell, event) {
      if (this.selectedCell) this.selectedCell.style.background = this.selectedCell.lastBack;
      this.clikedMoreDetailHeader = column.label;
      this.clickedMoreDetailBody = row[column.label];
      cell.lastBack = cell.style.background;
      cell.style.background = '#8af';
      this.selectedCell = cell;
    },
    cellMouseEnter: function cellMouseEnter(row, column, cell, event) {
      this.moreDetailHeader = column.label;
      this.moreDetailBody = row[column.label];
    },
    fetchQueryResult: function fetchQueryResult() {
      __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].getQueryResult(this.$route.params.id, this.$route.params.page).then(function (results) {
        if (results) {
          if (results.list) {
            this.list = results.list;
            this.reportName = results.name;
            this.totalPages = results.totalPages * 10;
            this.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.list[0]);
            this.reportQuery = results.query;
          } else if (results.error) {
            this.error = 'loading problem';
          }
        } else {
          this.error = 'loading problem';
        }
      }.bind(this));
    }
  },
  watch: {
    '$route': function $route() {
      this.list = null;
      this.fetchQueryResult();
    }
  },
  mounted: function mounted() {
    this.fetchQueryResult();
  },
  data: function data() {
    return {
      reportName: '',
      reportQuery: '',
      moreDetailBody: '',
      moreDetailHeader: '',
      error: '',
      totalPages: 1000,
      currentPage: this.$route.params.page,
      list: null,
      columns: []
    };
  }
});

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__searchBuilder_searchBuilder__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__searchBuilder_searchBuilder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__searchBuilder_searchBuilder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_database__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SearchBuilder: __WEBPACK_IMPORTED_MODULE_0__searchBuilder_searchBuilder___default.a
  },
  computed: {
    sortQuery: function sortQuery() {
      return __WEBPACK_IMPORTED_MODULE_2__services_database__["a" /* getSortQuery */](this.query.sort.fields, this.query.sort.isAscending);
    }
  },
  name: 'queryBuilder',
  methods: {
    save: function save() {
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].saveQuery(this.query).then(function (res) {
        if (res) {
          this.$router.push({ name: 'QueryResult', params: { id: res.data } });
          __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getQueries(true);
        }
      }.bind(this));
    },
    onContentChange: function onContentChange(e) {
      this.changeSourceContent();
    },
    changeSourceContent: function changeSourceContent() {
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].changeSourceContent(this.query.source, this.query.source_content);
      this.loadFields();
      this.query.sort_type = 'asc';
      this.query.sort_fields = [];
      this.query.groupBy = [];
      this.query.selected_fields = [];
      this.query.search = {
        jsonQuery: { operator: '', query: { field: '', operator: '', input: '' }, root: true },
        query: ''
      };
    },
    onSourceChanged: function onSourceChanged(e) {
      var _this = this;

      var selectedSources = this.sources.filter(function (source) {
        return source.value === _this.query.source;
      });
      if (selectedSources && selectedSources[0] && selectedSources[0].content) {
        this.contents = selectedSources[0].content;
        this.query.source_content = this.contents[0].value;
      }
    },
    loadFields: function loadFields() {
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getFields(this.query.source, this.query.source_content).then(function (fields) {
        this.fields = fields;
      }.bind(this));
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getSortableFields(this.query.source, this.query.source_content).then(function (fields) {
        this.sortable_fields = fields;
      }.bind(this));
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getGroupableFields(this.query.source, this.query.source_content).then(function (fields) {
        this.groupable_fields = fields;
      }.bind(this));
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].getSources().then(function (sources) {
      this.sources = sources;
      this.query.source = sources[0].value;
      this.contents = sources[0].content;
      this.query.source_content = this.contents[0].value;
      this.loadFields();
    }.bind(this));
  },
  data: function data() {
    return {
      contents: [],
      sources: [],
      query: {
        name: '',
        sort: {
          fields: [],
          isAscending: true
        },
        groupBy: [],
        source: '',
        source_content: '',
        selected_fields: [],
        search: {
          jsonQuery: { operator: '', query: { field: '', operator: '', input: '' }, root: true },
          query: ''
        }
      },
      fields: [],
      sortable_fields: [],
      groupable_fields: []
    };
  }
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fieldQuery',
  props: ['query'],
  computed: {
    fieldOperators: function fieldOperators() {}
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */].getFields().then(function (fields) {
      this.fields = fields;
    }.bind(this));
  },
  data: function data() {
    return {
      inputFrom: '',
      inputTo: '',
      matchInput: '',
      fields: [{ label: 'id', value: 'id', type: 'int' }, { label: 'content', value: 'content', type: 'string' }, { label: 'date', value: 'date', type: 'string' }],
      operators: [{ label: 'equal', value: 'equal', types: 'int,string,date' },
      //          {label: 'not equal', value: 'notEqual', types: 'int,string,date'},
      { label: 'greater than', value: 'gt', types: 'int,date' }, { label: 'less than', value: 'lt', types: 'int,date' }, { label: 'contain', value: 'contain', types: 'string' }, { label: 'between', value: 'between', types: 'int,date' }],
      selectedOperator: '',
      selectedField: ''
    };
  },

  methods: {
    getFieldOperator: function getFieldOperator() {
      var fieldType = this.getFieldType();
      return this.operators.filter(function (operator) {
        return operator.types.indexOf(fieldType) > -1;
      });
    },
    getFieldType: function getFieldType() {
      if (this.fields) {
        var filtered = this.fields.filter(function (field) {
          return field.value === this.query.field;
        }.bind(this));
        if (filtered && filtered[0]) {
          return filtered[0].type;
        }
      }
      return '';
    },

    fieldChanged: function fieldChanged(e) {
      this.query.operator = '';
      this.query.input = '';
      this.onChange(e);
    },
    onChange: function onChange(e) {
      var fieldType = this.getFieldType();
      var output = '';
      var operator = this.query.operator;
      var field = this.query.field;
      var input = this.query.input;

      if (operator === 'lt') {
        output = field + ' : [ * TO ' + input + ' ] ';
      } else if (operator === 'gt') {
        output = field + ' : [ ' + input + ' TO * ] ';
      } else if (operator === 'between') {
        output = field + ' : [' + this.inputFrom + ' TO ' + this.inputTo + ']';
      } else if (operator === 'contain') {
        output = field + ' : *' + input + '*';
      } else if (operator === 'equal') {
        output = field + ' : ';
        if (fieldType === 'string') {
          output += '"' + input + '"';
        } else {
          output += input;
        }
      }
      this.query.q = output;
      //      this.query.q = this.query.field + ' ' + this.query.operator + ' ' + this.query.input
      this.$emit('change');
    }
  },
  events: {}
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operatorBuilder_operatorBuilder__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_database__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    operatorBuilder: __WEBPACK_IMPORTED_MODULE_0__operatorBuilder_operatorBuilder__["a" /* default */]
  },
  props: {
    initialData: Object
  },
  created: function created() {},

  methods: {
    queryChanged: function queryChanged() {
      this.initialData.query = __WEBPACK_IMPORTED_MODULE_1__services_database__["b" /* extractSearchQuery */](this.initialData.jsonQuery);
    }
  },
  name: 'searchBuilder',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var serverURL = 'api/';

var RestResource = function () {
  function RestResource() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RestResource);

    this.errors = [];
    this.fields = {};
    this.reports = null;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RestResource, [{
    key: 'changeSourceContent',
    value: function changeSourceContent(source, sourceContent) {
      this.defaultSource = source;
      this.defaultContent = sourceContent;
    }
  }, {
    key: 'getFields',
    value: function getFields(source, sourceContent) {
      // if (this.fields[source] && this.fields[source][sourceContent]) {
      //   return Promise.resolve(this.fields[source][sourceContent])
      // } else {
      //   if (!this.fields[source]) this.fields[source] = {}
      //   this.fields[source][sourceContent] = axios.get(serverURL + 'dynamic_fields', {
      //     params: {
      //       source: source,
      //       source_content: sourceContent
      //     },
      //     withCredentials: true
      //   })
      //     .then(response => {
      //       response.data.items.map((field) => {
      //         field.key = field.value = field.name
      //         field.sortable = field.sort
      //         field.groupable = field.group
      //       })
      //       this.fields[source][sourceContent] = response.data.items
      //       return this.fields[source][sourceContent]
      //     })
      //     .catch(e => {
      //       this.errors.push(e)
      //     })
      //   return this.fields[source][sourceContent]
      // }

      // value had better to be uniqe
      // type could be string | int | date
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([{ key: 'id', value: 'id', name: 'id', type: 'int', groupable: true, sortable: true }, { key: 'name', value: 'name', name: 'name', type: 'string', groupable: true, sortable: true }, { key: 'title', value: 'title', name: 'title', type: 'string', groupable: true, sortable: false }, { key: 'content', value: 'content', name: 'content', type: 'string', groupable: true, sortable: true }, { key: 'date', value: 'date', name: 'date', type: 'date', groupable: false, sortable: false }, { key: 'likes', value: 'likes', name: 'likes', type: 'int', groupable: false, sortable: true }, { key: 'score', value: 'score', name: 'score', type: 'int', groupable: false, sortable: false }]);
    }
  }, {
    key: 'getSortableFields',
    value: function getSortableFields(source, content) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.getFields(source, content).then(function (fields) {
          resolve(fields.filter(function (field) {
            return field.sortable;
          }));
        });
      });
    }
  }, {
    key: 'getGroupableFields',
    value: function getGroupableFields(source, content) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.getFields(source, content).then(function (fields) {
          resolve(fields.filter(function (field) {
            return field.groupable;
          }));
        });
      });
    }
  }, {
    key: 'getQueries',
    value: function getQueries(reload) {
      // if (this.reports && !reload) {
      //   return Promise.resolve(this.reports)
      // } else {
      //   this.reports = axios.get(serverURL + 'dynamic_reports', {
      //     params: {
      //       user_id: 1
      //     }
      //   })
      //     .then(response => {
      //       response.data.items.map(s => { s.name = s.reportname; s.id = s.report_id })
      //       this.reports = response.data.items
      //       return this.reports
      //     })
      //     .catch(e => {
      //       this.errors.push(e)
      //     })
      //   return this.reports
      // }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([{ id: 1, name: 'importants' }, { id: 2, name: 'related with' }, { id: 3, name: 'conservatives' }, { id: 4, name: 'today' }, { id: 5, name: 'important in last month' }]);
    }
  }, {
    key: 'getQuery',
    value: function getQuery(id) {
      // return axios.get(serverURL + 'dynamic_reports?user_id=1')
      //   .then(response => {
      //     return response.data
      //   })
      //   .catch(e => {
      //     this.errors.push(e)
      //   })
      // const filteredReport = this.reports.filter((report) => report.id === id)
      // return Promise.resolve(filteredReport.length ? filteredReport[0] : {})
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({ 'report_name': 'popularity', 'sort_type': 'asc', 'sort_fields': ['likes'], 'groupBy': ['date'], 'source': 'source2', 'source_content': 'post', 'selected_fields': [], 'search': { 'jsonQuery': { 'operator': 'AND', 'query': '', 'root': true, 'subQueries': [{ 'operator': 'OR', 'query': '', 'subQueries': [{ 'operator': '', 'query': { 'field': 'content', 'operator': 'contain', 'input': 'mojtaba', 'q': 'content : *mojtaba*' } }, { 'operator': '', 'query': { 'field': 'content', 'operator': 'contain', 'input': 'fingerpich', 'q': 'content : *fingerpich*' } }] }, { 'operator': '', 'query': { 'field': 'likes', 'operator': 'gt', 'input': '20', 'q': 'likes : [ 20 TO * ] ' } }] }, 'query': ' (  ( content : *mojtaba* OR content : *fingerpich* )  AND likes : [ 20 TO * ]  ) ' } });
    }
  }, {
    key: 'getQueryResult',
    value: function getQueryResult(queryID, page) {
      // return axios.get(serverURL + 'load', {
      //   params: {
      //     id: queryID,
      //     page_number: page,
      //   }
      // })
      //   .then(response => {
      //     if (response.data) {
      //       return {
      //         query: response.data.query,
      //         name: response.data.name,
      //         list: response.data.list,
      //         totalPages: response.data.totalPages
      //       }
      //     } else {
      //       return {error: 1}
      //     }
      //   })
      //   .catch(e => {
      //     this.errors.push(e)
      //   })
      var arr = [{ name: 'ascasc', content: 'wvew vewr rcasc', category: 'csvdcsv', tag: 'csvdcsv', keyword: 'cwvwv', title: 'rcwvew cwvwv', published_date: '1/2/1392', google_score: 5352321, alexa_score: 3353352 }, { name: 'vewrvw', content: 'ewer werc cwrvw', category: 'wswdwsw', tag: 'wswdwsw', keyword: 'wewew', title: 'cwewer wewew', published_date: '2/4/1392', google_score: 3532525, alexa_score: 5538532 }, { name: 'wercwe', content: 'vjhn jhni ircwe', category: 'svjcsvj', tag: 'svjcsvj', keyword: 'rvjvj', title: 'irvjhn rvjvj', published_date: '2/7/1392', google_score: 2421415, alexa_score: 4426421 }, { name: 'jhnijv', content: 'fokj okjs snijv', category: 'swowswo', tag: 'swowswo', keyword: 'nfofo', title: 'snfokj nfofo', published_date: '1/5/1392', google_score: 2321315, alexa_score: 5635321 }, { name: 'okjsdf', content: 'vmen menr rjsdf', category: 'sjmrsjm', tag: 'sjmrsjm', keyword: 'jvmvm', title: 'rjvmen jvmvm', published_date: '8/3/1392', google_score: 7871815, alexa_score: 3653871 }, { name: 'menrbv', content: 'rbvmen me enrbv', category: 'sobnsob', tag: 'sobnsob', keyword: 'nrbrb', title: 'enrbvmenrbrb', published_date: '3/9/1392', google_score: 5651615, alexa_score: 2642651 }, { name: 'wercwe', content: 'vjhn jhni ircwe', category: 'svjcsvj', tag: 'svjcsvj', keyword: 'rvjvj', title: 'irvjhn rvjvj', published_date: '2/7/1392', google_score: 2421415, alexa_score: 4426421 }, { name: 'jhnijv', content: 'fokj okjs snijv', category: 'swowswo', tag: 'swowswo', keyword: 'nfofo', title: 'snfokj nfofo', published_date: '1/5/1392', google_score: 2321315, alexa_score: 5635321 }, { name: 'okjsdf', content: 'vmen menr rjsdf', category: 'sjmrsjm', tag: 'sjmrsjm', keyword: 'jvmvm', title: 'rjvmen jvmvm', published_date: '8/3/1392', google_score: 7871815, alexa_score: 3653871 }, { name: 'menrbv', content: 'rbvmen me enrbv', category: 'sobnsob', tag: 'sobnsob', keyword: 'nrbrb', title: 'enrbvmenrbrb', published_date: '3/9/1392', google_score: 5651615, alexa_score: 2642651 }, { name: 'wercwe', content: 'vjhn jhni ircwe', category: 'svjcsvj', tag: 'svjcsvj', keyword: 'rvjvj', title: 'irvjhn rvjvj', published_date: '2/7/1392', google_score: 2421415, alexa_score: 4426421 }, { name: 'jhnijv', content: 'fokj okjs snijv', category: 'swowswo', tag: 'swowswo', keyword: 'nfofo', title: 'snfokj nfofo', published_date: '1/5/1392', google_score: 2321315, alexa_score: 5635321 }, { name: 'okjsdf', content: 'vmen menr rjsdf', category: 'sjmrsjm', tag: 'sjmrsjm', keyword: 'jvmvm', title: 'rjvmen jvmvm', published_date: '8/3/1392', google_score: 7871815, alexa_score: 3653871 }, { name: 'okjsdf', content: 'vmen menr rjsdf', category: 'sjmrsjm', tag: 'sjmrsjm', keyword: 'jvmvm', title: 'rjvmen jvmvm', published_date: '8/3/1392', google_score: 7871815, alexa_score: 3653871 }, { name: 'menrbv', content: 'rbvmen me enrbv', category: 'sobnsob', tag: 'sobnsob', keyword: 'nrbrb', title: 'enrbvmenrbrb', published_date: '3/9/1392', google_score: 5651615, alexa_score: 2642651 }, { name: 'wercwe', content: 'vjhn jhni ircwe', category: 'svjcsvj', tag: 'svjcsvj', keyword: 'rvjvj', title: 'irvjhn rvjvj', published_date: '2/7/1392', google_score: 2421415, alexa_score: 4426421 }, { name: 'jhnijv', content: 'fokj okjs snijv', category: 'swowswo', tag: 'swowswo', keyword: 'nfofo', title: 'snfokj nfofo', published_date: '1/5/1392', google_score: 2321315, alexa_score: 5635321 }, { name: 'okjsdf', content: 'vmen menr rjsdf', category: 'sjmrsjm', tag: 'sjmrsjm', keyword: 'jvmvm', title: 'rjvmen jvmvm', published_date: '8/3/1392', google_score: 7871815, alexa_score: 3653871 }, { name: 'menrbv', content: 'rbvmen me enrbv', category: 'sobnsob', tag: 'sobnsob', keyword: 'nrbrb', title: 'enrbvmenrbrb', published_date: '3/9/1392', google_score: 5651615, alexa_score: 2642651 }, { name: 'wercwe', content: 'vjhn jhni ircwe', category: 'svjcsvj', tag: 'svjcsvj', keyword: 'rvjvj', title: 'irvjhn rvjvj', published_date: '2/7/1392', google_score: 2421415, alexa_score: 4426421 }, { name: 'jhnijv', content: 'fokj okjs snijv', category: 'swowswo', tag: 'swowswo', keyword: 'nfofo', title: 'snfokj nfofo', published_date: '1/5/1392', google_score: 2321315, alexa_score: 5635321 }, { name: 'okjsdf', content: 'vmen menr rjsdf', category: 'sjmrsjm', tag: 'sjmrsjm', keyword: 'jvmvm', title: 'rjvmen jvmvm', published_date: '8/3/1392', google_score: 7871815, alexa_score: 3653871 }, { name: 'menrbv', content: 'rbvmen me enrbv', category: 'sobnsob', tag: 'sobnsob', keyword: 'nrbrb', title: 'enrbvmenrbrb', published_date: '3/9/1392', google_score: 5651615, alexa_score: 2642651 }, { name: 'wercwe', content: 'vjhn jhni ircwe', category: 'svjcsvj', tag: 'svjcsvj', keyword: 'rvjvj', title: 'irvjhn rvjvj', published_date: '2/7/1392', google_score: 2421415, alexa_score: 4426421 }, { name: 'jhnijv', content: 'fokj okjs snijv', category: 'swowswo', tag: 'swowswo', keyword: 'nfofo', title: 'snfokj nfofo', published_date: '1/5/1392', google_score: 2321315, alexa_score: 5635321 }];
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
        query: 'title : *fingerpich*',
        name: 'fingerpich',
        list: arr.filter(function (a) {
          return Math.random() > 0.5;
        }).slice(0, 10),
        totalPages: 220
      });

      // const filteredReport = this.reports.filter((report) => report.id === id)
      // return Promise.resolve(filteredReport.length ? filteredReport[0] : {})
    }
  }, {
    key: 'getSources',
    value: function getSources() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([{ label: 'source1', value: 'source1', content: [{ label: 'document', value: 'document' }] }, { label: 'source2', value: 'source2', content: [{ label: 'page', value: 'page' }, { label: 'user', value: 'user' }, { label: 'post', value: 'post' }, { label: 'comment', value: 'comment' }, { label: 'group', value: 'group' }] }]);
    }
  }, {
    key: 'saveQuery',
    value: function saveQuery(query) {
      var _this3 = this;

      console.log(query);
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(serverURL + 'save', query).then(function (response) {
        console.log(response);
        return response;
      }).catch(function (e) {
        _this3.errors.push(e);
      });
    }
  }]);

  return RestResource;
}();

var services = new RestResource();
/* harmony default export */ __webpack_exports__["a"] = (services);

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(229),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-560dfd08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(227),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-105255c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(228),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "queryResult"
  }, [_c('head-menu', [_c('a', {
    staticClass: "editQuery",
    attrs: {
      "href": '#/edit/' + _vm.$route.params.id
    }
  }, [_vm._v("Edit Query")])]), _vm._v(" "), _c('div', {
    staticClass: "queryContainer"
  }, [_c('h3', [_vm._v(_vm._s(_vm.reportName))]), _vm._v(" "), _c('div', {
    staticClass: "reportQuery"
  }, [_vm._v("\n      " + _vm._s(_vm.reportQuery) + "\n    ")]), _vm._v(" "), (_vm.list) ? _c('div', [_c('div', {
    on: {
      "mouseleave": _vm.mouseLeave
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "border": "",
      "stripe": ""
    },
    on: {
      "cell-mouse-enter": _vm.cellMouseEnter,
      "cell-click": _vm.cellMouseClick
    }
  }, _vm._l((_vm.columns), function(col) {
    return _c('el-table-column', {
      attrs: {
        "prop": col,
        "label": col
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalPages
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "moreDetail"
  }, [_c('h4', [_vm._v(_vm._s(_vm.moreDetailHeader))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.moreDetailBody))])])]) : _c('div', {
    staticClass: "tabl"
  }, [(_vm.error) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _c('div', [_vm._v("loading")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fieldOfQuery"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Field"
    },
    on: {
      "change": _vm.fieldChanged
    },
    model: {
      value: (_vm.query.field),
      callback: function($$v) {
        _vm.$set(_vm.query, "field", $$v)
      },
      expression: "query.field"
    }
  }, _vm._l((_vm.fields), function(field) {
    return _c('el-option', {
      key: field.value,
      attrs: {
        "label": field.label,
        "value": field.value
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": !_vm.query.field,
      "clearable": "",
      "placeholder": "Operator"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.query.operator),
      callback: function($$v) {
        _vm.$set(_vm.query, "operator", $$v)
      },
      expression: "query.operator"
    }
  }, _vm._l((_vm.getFieldOperator()), function(operator) {
    return _c('el-option', {
      key: operator.value,
      attrs: {
        "label": operator.label,
        "value": operator.value
      }
    })
  })), _vm._v(" "), (_vm.query.operator != 'between') ? _c('span', [_c('el-input', {
    attrs: {
      "disabled": !_vm.query.field || !_vm.query.operator,
      "placeholder": "match"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.query.input),
      callback: function($$v) {
        _vm.$set(_vm.query, "input", $$v)
      },
      expression: "query.input"
    }
  })], 1) : _c('span', [_c('el-input', {
    attrs: {
      "disabled": !_vm.query.field,
      "placeholder": "match"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.inputFrom),
      callback: function($$v) {
        _vm.inputFrom = $$v
      },
      expression: "inputFrom"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": !_vm.query.field,
      "placeholder": "match"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.inputTo),
      callback: function($$v) {
        _vm.inputTo = $$v
      },
      expression: "inputTo"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "operatorGenerator"
  }, [_c('operator-builder', {
    attrs: {
      "json-data": _vm.initialData.jsonQuery
    },
    on: {
      "operatorChange": _vm.queryChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "generatedQuery"
  }, [_vm._v("\n    " + _vm._s(this.initialData.query) + "\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('head-menu'), _vm._v(" "), _c('query-builder')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "queryBuilder"
  }, [_c('div', {
    staticClass: "level"
  }, [_c('h4', [_vm._v("Select Data Source")]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "Select a source"
    },
    on: {
      "change": _vm.onSourceChanged
    },
    model: {
      value: (_vm.query.source),
      callback: function($$v) {
        _vm.$set(_vm.query, "source", $$v)
      },
      expression: "query.source"
    }
  }, _vm._l((_vm.sources), function(source) {
    return _c('el-option', {
      key: source.value,
      attrs: {
        "label": source.label,
        "value": source.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "source content"
    },
    on: {
      "change": _vm.onContentChange
    },
    model: {
      value: (_vm.query.source_content),
      callback: function($$v) {
        _vm.$set(_vm.query, "source_content", $$v)
      },
      expression: "query.source_content"
    }
  }, _vm._l((_vm.contents), function(content) {
    return _c('el-option', {
      key: content.value,
      attrs: {
        "label": content.label,
        "value": content.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('h4', [_vm._v("Search Query")]), _vm._v(" "), _c('search-builder', {
    attrs: {
      "initialData": _vm.query.search
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "level sort"
  }, [_c('h4', [_vm._v("Sort")]), _vm._v(" "), _c('div', [_c('el-switch', {
    staticClass: "sortSwitch",
    attrs: {
      "on-color": "#13ce66",
      "on-text": "▽",
      "off-text": "△",
      "off-color": "#ff4949"
    },
    model: {
      value: (_vm.query.sort.isAscending),
      callback: function($$v) {
        _vm.$set(_vm.query.sort, "isAscending", $$v)
      },
      expression: "query.sort.isAscending"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.query.sort.fields),
      callback: function($$v) {
        _vm.$set(_vm.query.sort, "fields", $$v)
      },
      expression: "query.sort.fields"
    }
  }, _vm._l((_vm.sortable_fields), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.query.sort.fields.length) ? _c('div', {
    staticClass: "generatedQuery"
  }, [_vm._v("\n      " + _vm._s(this.sortQuery) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "level group"
  }, [_c('h4', [_vm._v("Group")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.query.groupBy),
      callback: function($$v) {
        _vm.$set(_vm.query, "groupBy", $$v)
      },
      expression: "query.groupBy"
    }
  }, _vm._l((_vm.groupable_fields), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('el-transfer', {
    attrs: {
      "titles": ['all fields', 'output fields'],
      "data": _vm.fields
    },
    model: {
      value: (_vm.query.selected_fields),
      callback: function($$v) {
        _vm.$set(_vm.query, "selected_fields", $$v)
      },
      expression: "query.selected_fields"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "save-query-container"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "initial"
    },
    attrs: {
      "placeholder": "query name"
    },
    model: {
      value: (_vm.query.name),
      callback: function($$v) {
        _vm.$set(_vm.query, "name", $$v)
      },
      expression: "query.name"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "dark",
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("Solr Query builder")])]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Queries")]), _vm._v(" "), _vm._l((_vm.reports), function(report) {
    return _c('el-menu-item', {
      key: report.id,
      attrs: {
        "index": "2-1"
      }
    }, [_c('a', {
      attrs: {
        "href": '#load/' + report.id
      }
    }, [_vm._v(_vm._s(report.name))])])
  })], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/new"
    }
  }, [_vm._v("New+")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extractSearchQuery;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSortQuery;

function solrSearchQueryGenerator(jsonData) {
  if (jsonData.subQueries) {
    return ' ( ' + jsonData.subQueries.map(function (subQuery) {
      return solrSearchQueryGenerator(subQuery);
    }).join(' ' + jsonData.operator + ' ') + ' ) ';
  } else {
    return (jsonData.operator === true ? '-' : '') + jsonData.query.q;
  }
}

function extractSearchQuery(jsonData) {
  return solrSearchQueryGenerator(jsonData);
}

function getSortQuery(fields, isAscending) {
  return 'sort = ' + fields.join(',') + ' ' + (isAscending ? 'asc' : 'desc');
}

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ec331870",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(230),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_QueryEditor__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_QueryEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_QueryEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_QueryResult__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_QueryResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_QueryResult__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    name: 'QueryEditor',
    component: __WEBPACK_IMPORTED_MODULE_2__components_QueryEditor___default.a
  }, {
    path: '/new',
    name: 'QueryEditor',
    component: __WEBPACK_IMPORTED_MODULE_2__components_QueryEditor___default.a
  }, {
    path: '/edit/:id',
    name: 'editQuery',
    component: __WEBPACK_IMPORTED_MODULE_2__components_QueryEditor___default.a
  }, {
    path: '/load/:id',
    name: 'QueryResult',
    component: __WEBPACK_IMPORTED_MODULE_3__components_QueryResult___default.a
  }, {
    path: '/load/:id/:page',
    name: 'QueryResultPagination',
    component: __WEBPACK_IMPORTED_MODULE_3__components_QueryResult___default.a
  }]
}));

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[136]);


// WEBPACK FOOTER //
// static/js/app.64a03a7d467e0e4d7a41.js